// extracted by mini-css-extract-plugin
export default {"partners":"Partners_partners__ZC0RM","h2":"Partners_h2__T6MTE","list":"Partners_list__MDsUR","onePartner":"Partners_onePartner__HT0dg","topDesc":"Partners_topDesc__r6bOS"};